import React, { createContext, useState, useEffect } from "react";
import api from "../utils/api";
import { hasAccessToken } from "../utils/token";

export const PlanningContext = createContext();

export const PlanningProvider = ({ children }) => {
  const [planning, setPlanning] = useState(() => {
    const saved = localStorage.getItem("planning");
    return saved === "true"; // defaults to false if null
  });

  useEffect(() => {
    if (!hasAccessToken()) return; // Skip fetch if not authenticated

    api.get("/planning")
      .then(res => {
        setPlanning(Boolean(res.data.planning));
        localStorage.setItem("planning", String(Boolean(res.data.planning)));
      })
      .catch(err => {
        console.error("Failed to fetch planning state from server:", err);
      });
  }, []);

  const togglePlanning = () => {
    setPlanning(prev => {
      const newValue = !prev;
      localStorage.setItem("planning", String(newValue));
      if (hasAccessToken()) {
        api.post("/planning", { planning: newValue })
          .catch(err => {
            console.error("Failed to update planning state on server:", err);
          });
      }
      return newValue;
    });
  };

  return (
    <PlanningContext.Provider value={{ planning, setPlanning, togglePlanning }}>
      {children}
    </PlanningContext.Provider>
  );
};
